export enum StudyListFilter {
    AllStudies = "allStudies",
    ToBeApproved = "toBeApproved",
    ToBeInterpreted = "toBeInterpreted",
    ToBeSigned = "toBeSigned",
    Signed = "signed",
}
